import { serviceLocator } from '@/utils/providers/serviceLocator'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import type { ChatRepository } from '../repositories/ChatRepository'

export async function connectToNotificationChannelCase() {
  const newRepository = serviceLocator.getService<ChatRepository>('ChatService')
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.connectToNotificationChannel(),
    key: 'chat',
    filterData: JSON.stringify(''),
    skipCaching: true
  })

  if (data.value?.error) return

  return data.value
}
